import { combineReducers } from 'redux';

import deal from './deal/reducer';
import fields from './fields/reducer';

export default combineReducers({
  allowStageChange: bool => bool || false,
  allowTypeChange: bool => bool || false,
  deal,
  features: features => features || {},
  fields,
  forUser: forUser => forUser || {},
  hidePropertySelector: bool => bool || false,
  invalidFields: invalidFields => invalidFields || [],
  options: options => options || {},
  paths: paths => paths || {},
  stagesConfig: stagesConfig => stagesConfig || {},
});
